import React, { RefObject } from "react";
import BaseForm from "./Form/BaseForm";
import { message } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

import { User, FormFieldConfig } from "../helpers/shared-interfaces";
import { FormInstance } from "antd/lib/form";
import { handleValidationErrors } from "../helpers/utilities";
import { generateDisplayErrorMessage } from "../helpers/utilities";


interface Feedback {
  description: string;
  summary: string;
}

interface Validated {
  url: string;
  title: string;
  description: string;
  email: string;
}

interface Props {
  handleSubmit: <T>(values: T) => void;
  isLoading: boolean;
}

function generateField(
  validateAndSubmit: () => void,
  user: User | null,
): FormFieldConfig[] {
  return [
    {
      id: "url",
      name: "url",
      required: false,
      inputType: "string",
      rule: "string",
      label: "Link",
      placeholder: "Link to page on which error is thrown",
      formItemStyle: { marginBottom: "-2px" },
      colConfig: {
        span: 24,
      },
    },
    {
      id: "email",
      name: "email",
      required: true,
      inputType: "email",
      rule: "email",
      label: "Email",
      initialValue: user?.email,
      placeholder: "Your Email",
      formItemStyle: { marginBottom: "-2px" },
      colConfig: {
        span: 24,
      },
    },
    {
      id: "title",
      name: "title",
      required: true,
      inputType: "string",
      rule: "string",
      label: "Title",
      placeholder: "Title",
      formItemStyle: { marginBottom: "-2px" },

      colConfig: {
        span: 24,
      },
    },
    {
      id: "description",
      name: "description",
      required: true,
      inputType: "textArea",
      rule: "string",
      label: "Description",
      formItemStyle: { marginBottom: "12px" },

      autoSize: { minRows: 6, maxRows: 6 },
      placeholder: "Fully describe the error you faced",
      colConfig: {
        span: 24,
      },
    },
    {
      id: "submitFeedback",
      name: "submitFeedback",
      inputType: "button",
      value: "Submit",
      required: false,

      className: "base-button",
      handleClick: validateAndSubmit,
      elementStyle: {
        position: "relative",
        left: "-10px",
      },
      colConfig: {
        offset: 1,
        span: 7,
      },
    },
  ];
}
export default class FeedbackForm extends React.Component<
  Props,
  Record<string, unknown>
> {
  reference: RefObject<FormInstance> = React.createRef<FormInstance>();

  setRef = (ref: React.RefObject<FormInstance>): void => {
    this.reference = ref;
  };

  validateAndSubmit = async (): Promise<void> => {
    const { handleSubmit } = this.props;

    if (!this.reference.current) {
      return;
    }
    const fieldsToValidate = ["url", "title", "description", "email"];

    try {
      const validatedData = await this.reference.current.validateFields(
        fieldsToValidate,
      );
      handleSubmit<Feedback>({
        description: `Page Url - ${validatedData.url} \n Description: ${validatedData.description} \n Email: ${validatedData.email}`,
        summary: validatedData.title,
      });
    } catch (error) {
      handleValidationErrors(error);
      message.error(
        `Fill all required fields for us to understand your issue better - ${generateDisplayErrorMessage(error)}`,
      );
    }
  };
  render(): JSX.Element {
    const { isLoading } = this.props;
    const user: User | null = JSON.parse(
      localStorage.getItem("user") as string,
    );
    return (
      <div id="feedbackForm">
        <h1>Feedback Form</h1>
        <hr />

        <BaseForm
          reference={this.reference}
          layout="vertical"
          fields={generateField(this.validateAndSubmit, user)}
          fieldsToHide={[]}
        />
        {isLoading && <LoadingOutlined />}
      </div>
    );
  }
}
